import { SvelteComponent, init, safe_not_equal, element, text, attr, insert, append, set_data, detach, space, create_component, src_url_equal, toggle_class, mount_component, listen, transition_in, transition_out, destroy_component, createEventDispatcher, noop } from '../../../../external_node_modules/svelte/internal/index.mjs.js';
import { t } from '../../../../i18n.js';
import Button from '../Button/Button.svelte.js';
import Decoration from '../Decoration/Decoration.svelte.js';
import '../../../../core/entity/product.entity.js';
import './ProductTile.css.js';

/* src/ui/shared/components/ProductTile/ProductTile.svelte generated by Svelte v3.44.2 */

function create_if_block_1(ctx) {
	let span;
	let t0;
	let t1_value = /*product*/ ctx[0].formattedDiscount + "";
	let t1;

	return {
		c() {
			span = element("span");
			t0 = text("-");
			t1 = text(t1_value);
			attr(span, "class", "tile-price-discount wcl-1c3nuld");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t0);
			append(span, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*product*/ 1 && t1_value !== (t1_value = /*product*/ ctx[0].formattedDiscount + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (44:10) {#if product.formattedOriginalPrice}
function create_if_block(ctx) {
	let span;
	let raw_value = /*product*/ ctx[0].formattedOriginalPrice + "";

	return {
		c() {
			span = element("span");
			attr(span, "class", "tile-price__old wcl-1c3nuld");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			span.innerHTML = raw_value;
		},
		p(ctx, dirty) {
			if (dirty & /*product*/ 1 && raw_value !== (raw_value = /*product*/ ctx[0].formattedOriginalPrice + "")) span.innerHTML = raw_value;		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (55:8) <Button disabled="{!product.isPurchasable}" on:click="{buyProduct}">
function create_default_slot(ctx) {
	let t_1_value = t('Купить') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

function create_fragment(ctx) {
	let div8;
	let div7;
	let div0;
	let img;
	let img_src_value;
	let img_alt_value;
	let t0;
	let div1;
	let t1;
	let div6;
	let decoration;
	let t2;
	let div2;
	let t3_value = /*product*/ ctx[0].title + "";
	let t3;
	let t4;
	let div4;
	let t5;
	let div3;
	let t6;
	let span;
	let raw_value = /*product*/ ctx[0].formattedPrice + "";
	let t7;
	let div5;
	let button;
	let div8_class_value;
	let current;
	let mounted;
	let dispose;

	decoration = new Decoration({
			props: {
				display: "row",
				product: /*product*/ ctx[0],
				hidePercent: true
			}
		});

	let if_block0 = /*product*/ ctx[0].formattedDiscount && create_if_block_1(ctx);
	let if_block1 = /*product*/ ctx[0].formattedOriginalPrice && create_if_block(ctx);

	button = new Button({
			props: {
				disabled: !/*product*/ ctx[0].isPurchasable,
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*buyProduct*/ ctx[1]);

	return {
		c() {
			div8 = element("div");
			div7 = element("div");
			div0 = element("div");
			img = element("img");
			t0 = space();
			div1 = element("div");
			t1 = space();
			div6 = element("div");
			create_component(decoration.$$.fragment);
			t2 = space();
			div2 = element("div");
			t3 = text(t3_value);
			t4 = space();
			div4 = element("div");
			if (if_block0) if_block0.c();
			t5 = space();
			div3 = element("div");
			if (if_block1) if_block1.c();
			t6 = space();
			span = element("span");
			t7 = space();
			div5 = element("div");
			create_component(button.$$.fragment);
			if (!src_url_equal(img.src, img_src_value = /*product*/ ctx[0].tileImageUrl)) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = /*product*/ ctx[0].title);
			attr(img, "class", "wcl-1c3nuld");
			attr(div0, "class", "tile-preview");
			attr(div1, "class", "tile-overlay wcl-1c3nuld");
			attr(div2, "class", "tile-title wcl-1c3nuld");
			attr(span, "class", "tile-price__current wcl-1c3nuld");
			attr(div3, "class", "tile-price wcl-1c3nuld");
			attr(div4, "class", "tile-price-wrapper wcl-1c3nuld");
			attr(div5, "class", "tile-buy wcl-1c3nuld");
			attr(div6, "class", "tile-bottom wcl-1c3nuld");
			attr(div7, "class", "tile-container wcl-1c3nuld");
			toggle_class(div7, "purchased", !/*product*/ ctx[0].isPurchasable);
			attr(div8, "class", div8_class_value = "tile tile" + /*product*/ ctx[0].tileSize + " wcl-1c3nuld");
		},
		m(target, anchor) {
			insert(target, div8, anchor);
			append(div8, div7);
			append(div7, div0);
			append(div0, img);
			append(div7, t0);
			append(div7, div1);
			append(div7, t1);
			append(div7, div6);
			mount_component(decoration, div6, null);
			append(div6, t2);
			append(div6, div2);
			append(div2, t3);
			append(div6, t4);
			append(div6, div4);
			if (if_block0) if_block0.m(div4, null);
			append(div4, t5);
			append(div4, div3);
			if (if_block1) if_block1.m(div3, null);
			append(div3, t6);
			append(div3, span);
			span.innerHTML = raw_value;
			append(div6, t7);
			append(div6, div5);
			mount_component(button, div5, null);
			current = true;

			if (!mounted) {
				dispose = listen(div8, "click", /*showDetails*/ ctx[2]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*product*/ 1 && !src_url_equal(img.src, img_src_value = /*product*/ ctx[0].tileImageUrl)) {
				attr(img, "src", img_src_value);
			}

			if (!current || dirty & /*product*/ 1 && img_alt_value !== (img_alt_value = /*product*/ ctx[0].title)) {
				attr(img, "alt", img_alt_value);
			}

			const decoration_changes = {};
			if (dirty & /*product*/ 1) decoration_changes.product = /*product*/ ctx[0];
			decoration.$set(decoration_changes);
			if ((!current || dirty & /*product*/ 1) && t3_value !== (t3_value = /*product*/ ctx[0].title + "")) set_data(t3, t3_value);

			if (/*product*/ ctx[0].formattedDiscount) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(div4, t5);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*product*/ ctx[0].formattedOriginalPrice) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					if_block1.m(div3, t6);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if ((!current || dirty & /*product*/ 1) && raw_value !== (raw_value = /*product*/ ctx[0].formattedPrice + "")) span.innerHTML = raw_value;			const button_changes = {};
			if (dirty & /*product*/ 1) button_changes.disabled = !/*product*/ ctx[0].isPurchasable;

			if (dirty & /*$$scope*/ 32) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);

			if (dirty & /*product*/ 1) {
				toggle_class(div7, "purchased", !/*product*/ ctx[0].isPurchasable);
			}

			if (!current || dirty & /*product*/ 1 && div8_class_value !== (div8_class_value = "tile tile" + /*product*/ ctx[0].tileSize + " wcl-1c3nuld")) {
				attr(div8, "class", div8_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(decoration.$$.fragment, local);
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(decoration.$$.fragment, local);
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div8);
			destroy_component(decoration);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			destroy_component(button);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
		function adopt(value) {
			return value instanceof P
			? value
			: new P(function (resolve) {
						resolve(value);
					});
		}

		return new (P || (P = Promise))(function (resolve, reject) {
				function fulfilled(value) {
					try {
						step(generator.next(value));
					} catch(e) {
						reject(e);
					}
				}

				function rejected(value) {
					try {
						step(generator["throw"](value));
					} catch(e) {
						reject(e);
					}
				}

				function step(result) {
					result.done
					? resolve(result.value)
					: adopt(result.value).then(fulfilled, rejected);
				}

				step((generator = generator.apply(thisArg, _arguments || [])).next());
			});
	};

	let { product } = $$props;
	const dispatch = createEventDispatcher();

	function buyProduct() {
		return __awaiter(this, void 0, void 0, function* () {
			if (!product.isPurchasable) {
				return false;
			}

			dispatch('buy', { product });
		});
	}

	function showDetails() {
		dispatch('showDetails', { product });
	}

	$$self.$$set = $$props => {
		if ('product' in $$props) $$invalidate(0, product = $$props.product);
	};

	return [product, buyProduct, showDetails];
}

class ProductTile extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { product: 0 });
	}
}

export { ProductTile as default };
//# sourceMappingURL=ProductTile.svelte.js.map
